import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {ConfirmationDialogService} from '@brunata-angular/ui';
import {TranslatePipe, TranslateService} from '@brunata-angular/util';
import {ActionButtonComponent} from '../shared/ui/action-button/action-button.component';
import {ExportTestButtonComponent} from '../shared/ui/export-test-button/export-test-button.component';
import {StepFlowComponent} from '../steps/step-flow/step-flow.component';
import {
    CustomizedExportsFormService,
    customizedExportFormProviders,
} from './customized-exports-form.service';
import {CustomizedFlowContext, slotsForUsage} from './customized-exports.model';

@Component({
    selector: 'app-customized-exports',
    standalone: true,
    imports: [TranslatePipe, ExportTestButtonComponent, StepFlowComponent, ActionButtonComponent],
    templateUrl: './customized-exports.component.html',
    styles: `
        .title-row {
            max-width: 75.25rem;
        }

        .title-row > .btn {
            margin-block: -0.4375rem;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: customizedExportFormProviders,
})
// No unsaved-changes guard or beforeunload warning: the draft persists in local storage on every
// change and restores on return, so leaving the wizard loses nothing.
export class CustomizedExportsComponent {
    protected readonly form = inject(CustomizedExportsFormService);
    private readonly confirmationDialogService = inject(ConfirmationDialogService);
    private readonly translateService = inject(TranslateService);

    private readonly context: CustomizedFlowContext = {form: this.form};

    protected readonly slots = computed(() =>
        slotsForUsage(this.form.selectedUsage()).map(slot => ({
            id: slot.id,
            titleKey: slot.titleKey,
            body: {render: slot.render, bindings: slot.bind(this.context)},
        })),
    );

    protected startOver(): void {
        void this.confirmationDialogService
            .confirmWithSettings({
                title: this.translateService.translate('common_warning', 'online', 'common'),
                message: this.translateService.translate(
                    'customizedexports_export_reset_warning',
                    'online',
                    'export',
                ),
                centered: true,
            })
            .then(confirmed => {
                if (confirmed) {
                    this.form.reset();
                }
            });
    }
}
